import React from "react";
import { useParams } from "react-router-dom";
import "../styles/cadastroStyle/Cadastro.css";
import CadastroForm from "../components/cadastro/CadastroForm";

export default function Cadastro() {
  const { token } = useParams(); // <--- pega o token da URL

  return (
    <div className="cadastro-wrapper">
      <img
        src="/background-cidade.svg"
        alt="background"
        className="cadastro-bg"
      />

      <div className="cadastro-container">
        <img src="/logotact.svg" alt="Logo" className="cadastro-logo" />

        {/* passa o token para o form */}
        <CadastroForm token={token || ""} />
      </div>
    </div>
  );
}
